<template>
    <div class="profile-details">
        <form>
            <input
                v-if="isDataLoaded"
                type="hidden"
                name="id"
                :value="contact.id"
            />
            <input
                v-if="isDataLoaded"
                type="hidden"
                name="type"
                :value="isCompany ? 'business' : 'actor'"
            />
        </form>
        <loader-profile
            v-if="!isDataLoaded"
            :show-image="false"
        ></loader-profile>
        <b-row v-if="isDataLoaded">
            <b-col lg="4">
                <b-table-simple borderless>
                    <b-tbody v-if="isCompany">
                        <b-tr>
                            <b-th class="col-4">Name:</b-th>
                            <b-td class="col-8">
                                <span>{{ contact.name }}</span>
                            </b-td>
                        </b-tr>
                        <b-tr>
                            <b-th class="col-4">Phone:</b-th>
                            <b-td class="col-8">
                                <PhoneNumber
                                    :phone="contact.phone"
                                    :phoneCountry="contact.phone_country_code"
                                />
                            </b-td>
                        </b-tr>
                        <b-tr>
                            <b-th class="col-4">Fax:</b-th>
                            <b-td class="col-8">
                                <PhoneNumber
                                    :phone="contact.fax"
                                    :phoneCountry="contact.fax_country_code"
                                />
                            </b-td>
                        </b-tr>
                        <b-tr>
                            <b-th class="col-4">Website:</b-th>
                            <b-td class="col-8">
                                <a
                                    v-if="contact.website"
                                    :href="
                                        contact.website.includes('http')
                                            ? contact.website
                                            : 'http://' + contact.website
                                    "
                                    target="_blank"
                                    >{{ contact.website }}
                                </a>
                            </b-td>
                        </b-tr>
                        <b-tr>
                            <b-th class="col-4">Email:</b-th>
                            <b-td class="col-8">
                                <span>{{ contact.email }}</span>
                            </b-td>
                        </b-tr>
                    </b-tbody>
                    <b-tbody v-else>
                        <b-tr>
                            <b-th class="col-4">Salutation:</b-th>
                            <b-td class="col-8">
                                <span>{{ contact.salutation }}</span>
                            </b-td>
                        </b-tr>
                        <b-tr>
                            <b-th class="col-4">First Name:</b-th>
                            <b-td class="col-8">
                                <span>{{ contact.firstname }}</span>
                            </b-td>
                        </b-tr>
                        <b-tr>
                            <b-th class="col-4">Last Name:</b-th>
                            <b-td class="col-8">
                                <span>{{ contact.lastname }}</span>
                            </b-td>
                        </b-tr>
                        <b-tr>
                            <b-th class="col-4">Title:</b-th>
                            <b-td class="col-8">
                                <span>{{ contact.title }}</span>
                            </b-td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
            </b-col>
            <b-col lg="4">
                <b-table-simple borderless>
                    <b-tbody>
                        <b-tr>
                            <b-th class="col-4">Address:</b-th>
                            <b-td class="col-8">
                                <span>{{ contact.address }}</span>
                            </b-td>
                        </b-tr>
                        <b-tr>
                            <b-th class="col-4">Zipcode:</b-th>
                            <b-td class="col-8">
                                <span>{{ contact.zipcode }}</span>
                            </b-td>
                        </b-tr>
                        <b-tr>
                            <b-th class="col-4">City:</b-th>
                            <b-td class="col-8">
                                <span>{{ contact.city }}</span>
                            </b-td>
                        </b-tr>
                        <b-tr>
                            <b-th class="col-4">County:</b-th>
                            <b-td class="col-8">
                                <span>{{ contact.county }}</span>
                            </b-td>
                        </b-tr>
                        <b-tr>
                            <b-th class="col-4">State:</b-th>
                            <b-td class="col-8">
                                <span>{{ contact.state }}</span>
                            </b-td>
                        </b-tr>
                        <b-tr>
                            <b-th class="col-4">Country:</b-th>
                            <b-td class="col-8">
                                <span>{{ contact.country }}</span>
                            </b-td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
            </b-col>
            <b-col lg="4">
                <b-table-simple borderless>
                    <b-tbody v-if="isCompany">
                        <b-tr>
                            <b-th class="col-4">Account:</b-th>
                            <b-td class="col-8">
                                <span>{{ contact.account_no }}</span>
                            </b-td>
                        </b-tr>
                    </b-tbody>
                    <b-tbody v-else>
                        <b-tr>
                            <b-th class="col-4">Phone:</b-th>
                            <b-td class="col-8">
                                <PhoneNumber
                                    :phone="contact.work"
                                    :phoneCountry="contact.work_country_code"
                                />
                            </b-td>
                        </b-tr>
                        <b-tr>
                            <b-th class="col-4">Mobile:</b-th>
                            <b-td class="col-8">
                                <PhoneNumber
                                    :phone="contact.mobile"
                                    :phoneCountry="contact.mobile_country_code"
                                />
                            </b-td>
                        </b-tr>
                        <b-tr>
                            <b-th class="col-4">Fax:</b-th>
                            <b-td class="col-8">
                                <PhoneNumber
                                    :phone="contact.fax"
                                    :phoneCountry="contact.fax_country_code"
                                />
                            </b-td>
                        </b-tr>
                        <b-tr>
                            <b-th class="col-4">Email:</b-th>
                            <b-td class="col-8">
                                <span>{{ contact.email }}</span>
                            </b-td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import { isEmpty } from "lodash";
export default {
    components: {
        PhoneNumber: () => import("@/components/commons/phone-number"),
        LoaderProfile: () => import("@/components/elements/loader-profile.vue")
    },
    mounted() {},
    computed: {
        contact() {
            return this.$store.getters["contact/contactDetails"];
        },
        isDataLoaded() {
            return !isEmpty(this.$store.state.contact.contactDetails);
        },
        isCompany() {
            return this.$store.state.contact.isCompany;
        }
    },
    methods: {}
};
</script>
<style type="text/css" lang="scss" scoped>
.profile-details .table th,
.profile-details .table th .col-4 {
    /* Safari specific */
    @media (-webkit-min-device-pixel-ratio: 0) {
        width: 33.33333%;
        max-width: 33.33333%;
    }
}
.profile-details .table td {
    padding: 0px;
    line-height: 35px;
}
</style>
